import { isProd } from 'storfox-api-hooks'

export const FILE_URL = isProd
  ? 'https://storfox-prod-cdn.fra1.digitaloceanspaces.com/assets'
  : 'https://storfox-prod-cdn.fra1.digitaloceanspaces.com/assets';
